function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg182Grenada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#A2001D"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "256,256 44.522,467.478 44.522,44.522 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,256 467.478,467.478 44.522,467.478  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "467.478,44.522 256,256 44.522,44.522  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "467.478,44.522 467.478,467.478 256,256 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 256,
    cy: 256,
    r: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "255.999,192 270.345,236.153 316.774,236.153 279.215,263.445 293.56,307.6    255.999,280.311 218.437,307.6 232.785,263.445 195.226,236.153 241.652,236.153  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M122.607,251.481c7.027,11.104,3.724,25.798-7.379,32.827c-11.103,7.028-25.798,3.725-32.827-7.378   C69.677,256.828,77.055,224,77.055,224S109.882,231.379,122.607,251.481z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 108.867,
    cy: 274.254,
    r: 11.895
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,8.904 259.316,19.108 270.044,19.108 261.365,25.414 264.681,35.617 256,29.311    247.32,35.617 250.636,25.414 241.956,19.108 252.684,19.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "170.094,8.904 173.41,19.108 184.137,19.108 175.458,25.414 178.774,35.617 170.094,29.311    161.415,35.617 164.73,25.414 156.05,19.108 166.778,19.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "341.906,8.904 345.222,19.108 355.95,19.108 347.271,25.414 350.586,35.617 341.906,29.311    333.227,35.617 336.542,25.414 327.863,19.108 338.59,19.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,476.383 259.316,486.586 270.044,486.586 261.365,492.892 264.681,503.096 256,496.789    247.32,503.096 250.636,492.892 241.956,486.586 252.684,486.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "170.094,476.383 173.41,486.586 184.137,486.586 175.458,492.892 178.774,503.096    170.094,496.789 161.415,503.096 164.73,492.892 156.05,486.586 166.778,486.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "341.906,476.383 345.222,486.586 355.95,486.586 347.271,492.892 350.586,503.096    341.906,496.789 333.227,503.096 336.542,492.892 327.863,486.586 338.59,486.586  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg182Grenada);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };